// @flow
import BoxHeader from "./BoxHeader";

export default BoxHeader;
